var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.errors && _vm.errors.length
    ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
        _vm._v(_vm._s(_vm.defaultError))
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }